import { render, staticRenderFns } from "./CreateOrEditPost.vue?vue&type=template&id=ee35553c&scoped=true&"
import script from "./CreateOrEditPost.vue?vue&type=script&lang=js&"
export * from "./CreateOrEditPost.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrEditPost.vue?vue&type=style&index=0&id=ee35553c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee35553c",
  null
  
)

export default component.exports